import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as companyActions from "../../../../actions/company.actions";
import * as adminActions from "../../../../actions/admin.actions";

import Companies from "../components/Companies";

import parseAdvancedSearch from "../../../../utils/parseAdvancedSearch";
import parseFilters from "../../../../utils/parseFilters";
import {
  decodeSearchParams,
  getFinalQueryString
} from "../../../../utils/parseQueries";

class CompaniesContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      advancedSearch: [],
      filters: []
    };
  }

  componentWillMount() {
    this.setState({ ...decodeSearchParams(this.props.location.search) });
  }

  componentDidMount() {
    const filters = getFinalQueryString(
      parseFilters(this.state.filters) +
        parseAdvancedSearch(this.state.advancedSearch)
    );

    this.props.companyActions.getAdminCompanies(filters);
    this.props.companyActions.getAdminCompaniesCSVData(filters);
  }

  render() {
    return (
      <Companies
        advancedSearch={this.state.advancedSearch}
        companies={this.props.companies.data || []}
        companies_csv={_.get(this.props, "companies_csv.data") || []}
        filters={this.state.filters}
        getCsvData={this.props.companyActions.getAdminCompaniesCSVData}
        getTable={this.props.companyActions.getAdminCompanies}
        history={this.props.history}
        loading={this.props.loading}
        numberOfPages={this.props.companies.last_page}
        page={this.props.page}
        paginationCount={this.props.paginationCount}
        setPage={this.props.adminActions.setPage}
        setSort={this.props.adminActions.setSort}
        sortData={this.props.sortData}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    companies: state.company.companies,
    companies_csv: state.company.companies_csv,
    loading: state.company.loadingGetCompanies,
    page: state.admin.pagination.companies,
    paginationCount: adminActions.getPaginationCounts(state.admin.pagination),
    sortData: state.admin.sorting.companies
  };
};

const mapDispatchToProps = dispatch => {
  return {
    adminActions: bindActionCreators(adminActions, dispatch),
    companyActions: bindActionCreators(companyActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompaniesContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/companies/containers/CompaniesContainer.js